import { defineMessages } from "react-intl";

export const messages = defineMessages({
  localDevBannerLabel: {
    id: "rovo-extension.local-dev-banner.label.no-translate",
    defaultMessage: "LOCAL DEV",
    description:
      "The text is shown as a banner label at the top of the extension UI when running in local development mode to distinguish it from production. This string should NOT be translated.",
  },
});
